import {
  CCT_PATIENT_HISTORY_DATA_REQUEST,
  CCT_PATIENT_HISTORY_DATA_SUCCESS,
  CCT_PATIENT_HISTORY_DATA_FAILURE,
  CCT_PATIENT_HISTORY_SELECTED_PATIENT,
  CCT_PATIENT_HISTORY_SELECTED_RECORDING,
  CCT_FETCH_EVENT_HISTORY_REQUEST,
  CCT_FETCH_EVENT_HISTORY_SUCCESS,
  CCT_FETCH_EVENT_HISTORY_FAILURE,
  CCT_FETCH_EOS_REPORT_STATUS_REQUEST,
  CCT_FETCH_EOS_REPORT_STATUS_SUCCESS,
  CCT_FETCH_EOS_REPORT_STATUS_FAILURE,
} from './types';

const initialState = {
  recordings: {
    isFetching: false,
    data: [],
    error: {},
  },
  selectedPatinet: {},
  selectedRecording: {},
  eventHistory: {
    isFetching: false,
    data: [],
    error: {},
  },
  eosReportStatus: {
    isFetching: false,
    data: [],
    error: {},
  },
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CCT_PATIENT_HISTORY_DATA_REQUEST]: (state, action) => ({
    ...state,
    recordings: {
      isFetching: true,
      data: [],
      error: {},
    },
  }),
  [CCT_PATIENT_HISTORY_DATA_SUCCESS]: (state, action) => ({
    ...state,
    recordings: {
      isFetching: false,
      data: action.payload,
      error: {},
    },
  }),
  [CCT_PATIENT_HISTORY_DATA_FAILURE]: (state, action) => ({
    ...state,
    recordings: {
      isFetching: false,
      data: [],
      error: 'failed',
    },
  }),
  [CCT_PATIENT_HISTORY_SELECTED_PATIENT]: (state, action) => ({
    ...state,
    selectedPatinet: action.payload,
  }),
  [CCT_PATIENT_HISTORY_SELECTED_RECORDING]: (state, action) => ({
    ...state,
    selectedRecording: action.payload,
  }),
  [CCT_FETCH_EVENT_HISTORY_REQUEST]: (state, action) => ({
    ...state,
    eventHistory: {
      isFetching: true,
      data: [],
      error: {},
    },
  }),
  [CCT_FETCH_EVENT_HISTORY_SUCCESS]: (state, action) => ({
    ...state,
    eventHistory: {
      isFetching: false,
      data: action.payload,
      error: {},
    },
  }),
  [CCT_FETCH_EVENT_HISTORY_FAILURE]: (state, action) => ({
    ...state,
    eventHistory: {
      isFetching: false,
      data: [],
      error: 'failed',
    },
  }),
  [CCT_FETCH_EOS_REPORT_STATUS_REQUEST]: (state, action) => ({
    ...state,
    eosReportStatus: {
      isFetching: true,
      data: [],
      error: {},
    },
  }),
  [CCT_FETCH_EOS_REPORT_STATUS_SUCCESS]: (state, action) => ({
    ...state,
    eosReportStatus: {
      isFetching: false,
      data: action.payload,
      error: {},
    },
  }),
  [CCT_FETCH_EOS_REPORT_STATUS_FAILURE]: (state, action) => ({
    ...state,
    eosReportStatus: {
      isFetching: false,
      data: [],
      error: 'failed',
    },
  }),
};

//
// Reducer
// ------------------------------------
export const KardiaRxCCTPatientHistory = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};



// WEBPACK FOOTER //
// ./src/views/state/KardiaRxCCTPatientHistory/KardiaRxCCTPatientHistoryReducers.js